import React from "react";
import { getPQRValue, getColumnClasses } from "./pqrDataUtils";
import { pqrStyles } from "./pqrStyles";

const PQRWeldingProcessTable = ({ pdf, type = "Groove", index = null }) => {
  const isOverlay = type === "Overlay";
  const { colwidth, col1Class, col2Class, col3Class } = getColumnClasses(pdf);

  // Single column mode for page 2
  if (index !== null) {
    const singleColClass = "left7-td-noright2";
    const singleColWidth = "90%";

    return (
      <>
        <div style={pqrStyles.group}>
          <div className="PQRbasemetal">WELDING PROCESSES</div>
        </div>
        <div style={pqrStyles.container}>
          <table id="table" className="PQRTable2">
            <tbody>
              <tr className="PQRtrhide PQR_noleft" style={isOverlay ? { borderBottom: "none" } : {}}>
                <th className="PQR_border PQRfillerMetalth" style={{ width: "27%", ...(isOverlay && { borderBottom: "none" }) }}>
                  Welding Process & Type
                </th>
                <td className={singleColClass} style={{ width: singleColWidth }}>
                  {getPQRValue(pdf[index]?.PQR_Process_Category)} {pdf[index] ? " & " : ""}{getPQRValue(pdf[index]?.PQR_Type)}
                </td>
              </tr>
              {isOverlay && (
                <tr className="PQRtrhide PQR_noleft" style={{ borderTop: "none" }}>
                  <th className="PQR_border PQRfillerMetalth" style={{ width: "27%", borderTop: "none" }}>
                    Layer
                  </th>
                  <td className={singleColClass} style={{ width: singleColWidth, borderTop: "none" }}>
                    {getPQRValue(pdf[index]?.PQR_Layer)}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </>
    );
  }

  // Multi-column mode for page 1
  return (
    <>
      <div style={pqrStyles.group}>
        <div className="PQRbasemetal">WELDING PROCESSES</div>
      </div>
      <div style={pqrStyles.container}>
        <table id="table" className="PQRTable2">
          <tbody>
            <tr className="PQRtrhide PQR_noleft" style={isOverlay ? { borderBottom: "none" } : {}}>
              <th className="PQR_border PQRfillerMetalth" style={{ width: "27%", ...(isOverlay && { borderBottom: "none" }) }}>
                Welding Process & Type
              </th>
              <td className={col1Class} style={{ width: colwidth }}>
                {getPQRValue(pdf[1]?.PQR_Process_Category)} {pdf[1] && " & "}{getPQRValue(pdf[1]?.PQR_Type)}
              </td>
              <td className={col2Class} style={{ width: colwidth }}>
                {getPQRValue(pdf[2]?.PQR_Process_Category)} {pdf[2] && " & "}{getPQRValue(pdf[2]?.PQR_Type)}
              </td>
              <td className={col3Class} style={{ width: colwidth }}>
                {getPQRValue(pdf[3]?.PQR_Process_Category)} {pdf[3] && " & "}{getPQRValue(pdf[3]?.PQR_Type)}
              </td>
            </tr>
            {isOverlay && (
              <tr className="PQRtrhide PQR_noleft" style={{ borderTop: "none" }}>
                <th className="PQR_border PQRfillerMetalth" style={{ width: "27%", borderTop: "none" }}>
                  Layer
                </th>
                <td className={col1Class} style={{ width: colwidth, borderTop: "none" }}>
                  {getPQRValue(pdf[1]?.PQR_Layer)}
                </td>
                <td className={col2Class} style={{ width: colwidth, borderTop: "none" }}>
                  {getPQRValue(pdf[2]?.PQR_Layer)}
                </td>
                <td className={col3Class} style={{ width: colwidth, borderTop: "none" }}>
                  {getPQRValue(pdf[3]?.PQR_Layer)}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default PQRWeldingProcessTable;